import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function DeschideFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Este doar despre bani?',
    a: 'Nu. Este despre abundență completă: sănătate, relații, liniște, bani, împlinire. Banii sunt o parte, dar abundența adevărată înseamnă să ai din plin pe toate planurile vieții.'
  }, {
    q: 'Trebuie să am experiență în dezvoltare personală?',
    a: 'Nu. Totul este explicat simplu și este aplicabil imediat. Nu ai nevoie de cunoștințe anterioare. Singura condiție e să fii deschisă la ideea că ceea ce simți și crezi influențează ceea ce atragi în viață.'
  }, {
    q: 'Chiar pot vedea rezultate rapide?',
    a: 'Da. Meditația pentru pacea minții funcționează din prima utilizare. Dacă aplici exercițiile zilnic, mulți participanți observă schimbări concrete în starea lor și în oportunitățile care apar în câteva săptămâni.'
  }, {
    q: 'Ce înseamnă "a primi"?',
    a: 'Înseamnă să permiți vieții să îți ofere lucruri bune fără rezistență, fără vinovăție și fără sentimentul că nu meriți. Mulți oameni sunt foarte buni la a da, dar se blochează când vine vorba de a primi. Acest curs deblochează exact acest tipar.'
  }, {
    q: 'Este potrivit dacă sunt stresată sau obosită?',
    a: 'Da, mai ales dacă ești stresată sau obosită. Cursul include o meditație specifică pentru liniștirea minții și tehnici de reîncărcare energetică pe care le poți folosi oricând simți că te golești.'
  }, {
    q: 'Pot cumpăra doar acest curs fără tot pachetul Academiei?',
    a: 'Da. Cursul se poate achiziționa separat la 500 lei cu acces pe viață. Dacă vrei toate cele 6 cursuri plus întâlniri de grup, Programul Standard complet costă 1.985 lei integral și economisești față de cumpărarea separată.'
  }, {
    q: 'Ce este propoziția win-win?',
    a: 'Este o unealtă practică pe care o înveți în curs și pe care o aplici în negocieri, în relații și în viața de zi cu zi. Adrian a folosit-o personal pentru a semna contracte care i-au adus venituri de peste 100.000 de euro în 3 ani. În curs primești instrucțiunile complete de aplicare.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1033">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1034">
        <SectionHeading title="Întrebări Frecvente" data-id="element-1035" />

        <div className="space-y-4 mb-16" data-id="element-1036">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-1037">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-1038">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-1039">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-1040" />
              </button>
              <AnimatePresence data-id="element-1041">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-1042">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-1043">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1044">
          <CTAButton data-id="element-1045" />
        </motion.div>
      </div>
    </section>;
}